// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Snow_wrapper__syc0r","container":"Snow_container__fNULA","overlay":"Snow_overlay__LiWm0"};